export default __webpack_public_path__ + "static/media/m_wdt_c_3.af2256a9.mp3";